module.exports = __webpack_public_path__ + "img/crustaces-en-ligne-boutrais.01a814e1.png";